<template>
  <div>
    <el-card>
      <app-breadcrumb :items="items"></app-breadcrumb>
    </el-card>
    <br />
    <el-card>
      <h2 class="title">
        Accessos por Rango Fecha
        <i
          class="custom__icon"
          :class="(opentableShowGroup ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowDate')"
        ></i>
      </h2>
      <br />
      <el-date-picker
        @change="searchInTableDate()"
        v-model="searchDate"
        type="daterange"
        format="dd/MM/yyyy"
        range-separator="a"
        :default-time="['09:00:00','09:00:00']"
        start-placeholder="Fecha Inicio"
        end-placeholder="Fecha Final"
        :picker-options="{firstDayOfWeek: 1}"
      ></el-date-picker>
      <app-table-paginate
        :key="reloadDate"
        v-show="tableShowDate"
        routeDelete="no"
        selection="no"
        :tableQuery="listAPIDate"
        :tableColumns="tableColumns"
        :limit="limit"
        :search="false"
        :noDisplayActions="true"
        :expand="true"
        :expandData="'paginas'"
        :expandColumns="expandColumns"
      ></app-table-paginate>
    </el-card>
    <br />
    <el-card>
      <h2 class="title">
        Accessos por página
        <i
          class="custom__icon"
          :class="(opentableShowGroup ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowGroup')"
        ></i>
      </h2>
      <br />
      <app-table-paginate
        :key="reloadTable"
        v-show="tableShowGroup"
        routeDelete="no"
        selection="no"
        :tableQuery="getList"
        :tableColumns="tableColumns"
        :limit="limit"
        :search="true"
        :noDisplayActions="true"
        :expand="true"
        :expandData="'paginas'"
        :expandColumns="expandColumns"
      ></app-table-paginate>
    </el-card>
    <br />

    <el-card>
      <h2 class="title">
        Gráficas
        <i
          class="custom__icon"
          :class="(opentableShowChart ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowChart')"
        ></i>
      </h2>
      <el-row :gutter="24" v-show="tableShowChart">
        <el-col :span="24">
          <app-chart
            v-if="dataSource"
            type="dragcolumn2d"
            :width="width"
            :height="height"
            :dataFormat="dataFormat"
            :dataSource="dataSource"
          ></app-chart>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import moment from "moment-timezone";
import breadcrumb from "@/components/_commons/breadcrumb";
import chart from "@/components/_commons/chart";
import { DatePicker } from "element-ui";

export default {
  name: "historico-de-acceso-date-resumen",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb,
    "app-chart": chart,
    "el-date-picker": DatePicker
  },

  created() {
    this.get();
  },
  data() {
    return {
      reloadTable: 0,
      reloadDate: 0,
      width: "100%",
      height: "400",
      dataFormat: "json",
      dataSource: {
        chart: {
          caption: "Accesos por fecha",
          yaxismaxvalue: this.max,
          theme: "fusion",
          plotToolText: "<b>$label</b><br>$seriesName: <b>$dataValue</b>"
        },
        categories: [
          {
            category: null
          }
        ],
        dataset: null
      },
      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/access-history",
          label: "Histórico de accesos por página"
        }
      ],
      listAPI: false,
      listAPIDate: [],
      loading: true,
      tableColumns: [
        {
          prop: "fecha",
          label: "Fecha"
        },
        {
          prop: "accesos",
          label: "Accesos"
        }
      ],
      expandColumns: [
        {
          prop: "page",
          label: "Página"
        },
        {
          prop: "acc",
          label: "N.Usuarios"
        },
        {
          prop: "path",
          label: "URL"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShowGroup: false,
      opentableShowGroup: false,
      opentableShowChart: false,
      tableShowChart: false,
      tableShowDate: false,
      searchDate: ""
    };
  },
  methods: {
    toggle(table) {
      this["open" + table] = !this["open" + table];
      this[table] = !this[table];
    },
    async get() {
      ApiService.post("auditoria/access-data-history-resumen", {
        token: localStorage.getItem("token")
      }).then(response => {
        let fechas = [],
          serieAccesos = [
            {
              seriesname: "Accesos",
              data: []
            }
          ];

        this.listAPI = response.data.filter(e => {
          e.fecha = moment(e.fecha).format("DD-MM-YYYY");
          fechas.push({
            label: e.fecha
          });
          serieAccesos[0].data.push({
            value: e.accesos,
            alpha: "100"
          });
          this.reloadTable++;
          return e;
        });
        this.dataSource.categories[0].category = fechas;
        this.dataSource.dataset = serieAccesos;
      });
    },
    searchInTableDate() {
      ApiService.post("auditoria/access-data-history-resumen-by-date", {
        token: localStorage.getItem("token"),
        dates: this.searchDate
      }).then(response => {
        this.listAPIDate = response.data;
        this.reloadDate++;
        this.tableShowDate = true;
      });
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    }
  }
};
</script>


<style lang="scss" scoped>
.el-breadcrumb {
  margin-bottom: 0 !important;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/accessDatehistoryResumen.vue